import { Card, MenuItem, Pagination, PaginationItem, Select } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

/* Page numbers, and optionally a page-size picker. Pages that do not pass
   `rowsPerPage` render exactly as before. */
export default function PaginationGlobal(props) {

    const { rowsPerPage, onRowsPerPageChange, rowsPerPageOptions = [15, 25, 50] } = props;
    const showSize = Boolean(rowsPerPage && onRowsPerPageChange);

    return (
        <Card className={`wh-pager${showSize ? ' wh-pager--sized' : ''}`}>
            {showSize && (
                <div className="wh-pager-size">
                    <span>Rows per page</span>
                    <Select size="small" value={rowsPerPage}
                        onChange={(e) => onRowsPerPageChange(Number(e.target.value))}>
                        {rowsPerPageOptions.map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                    </Select>
                </div>
            )}
            <Pagination sx={{ mb: 1, mt: 1, display: "flex", justifyContent: 'center' }} size='medium' variant="outlined" shape="rounded" count={props.count} showFirstButton
                page={props.pageNumber} color='primary'
                showLastButton onChange={(e, value) => props.func(value)}
                renderItem={(item) =>
                    <PaginationItem slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}  {...item}></PaginationItem>}
            >
            </Pagination>
        </Card>
    )
}
